// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"73c8a440","123":"4f6327a9","191":"3718d136","453":"8d97b4a4","455":"7bf3d613","541":"9d0600a9","800":"afcee9fb","977":"935198b0"}[chunkId] + ".chunk.js";
};